import PageAccueil from './components/PageAccueil.vue';

const routes = [
    { path: '/', component: PageAccueil, name: 'PageAccueil' },
];

export default routes;